import { render, staticRenderFns } from "./ActionItems.vue?vue&type=template&id=147cc342&scoped=true&"
import script from "./ActionItems.vue?vue&type=script&lang=js&"
export * from "./ActionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147cc342",
  null
  
)

export default component.exports